export const FINANCES = Object.freeze({
    CHANNEL: {
        COMMON: 1
    }
})
